<!-- ORGANISM: DrawerHeader.vue -->
<!-- Navigation drawer header — switches between expanded and rail header based on drawer state. -->

<script setup lang="ts">
//
// Imports
//
import DrawerHeaderExpanded from "../molecules/DrawerHeaderExpanded.vue";
import DrawerHeaderRail from "../molecules/DrawerHeaderRail.vue";

//
// Props & Emits
//
defineProps<{
  appLogoExpandedMode?: string | null;
  appLogoRailMode?: string | null;
  appName?: string;
  userName?: string;
  userEmail?: string;
}>();

//
// Composables
//
const { drawerRailMode } = useDrawer();
</script>

<template>
  <DrawerHeaderExpanded
    v-if="!drawerRailMode"
    :app-logo-expanded-mode="appLogoExpandedMode"
    :app-name="appName"
    :user-name="userName"
    :user-email="userEmail"
  />

  <DrawerHeaderRail v-else :app-logo-rail-mode="appLogoRailMode" />
</template>
